import Vue from 'vue'
import moment from 'moment';
import { GapState, GapFilter, GapPatientFilter, GapLogEntry, GapRecord } from './types'

const getDefaultState = () => {
    const state: GapState = {
        campaigns: [],
        insurers: [],
        providers: [],
        measures: [],
        measureTypes: [],
        measureTypeTemplates: [],
        priority: [],
        status: [],
        subStatus: [],
        closeReasons: [],
        logTypes: []
    }
    return state;
}

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        SET_CAMPAIGNS(state: GapState, campaigns: Array<any>) {
            state.campaigns = campaigns;
        },
        SET_INSURERS(state: GapState, insurers: Array<any>) {
            state.insurers = insurers;
        },
        SET_PROVIDERS(state: GapState, providers: Array<any>) {
            state.providers = providers;
        },
        SET_MEASURES(state: GapState, measures: Array<any>) {
            state.measures = measures;
        },
        SET_MEASURE_TYPES(state: GapState, measureTypes: Array<any>) {
            state.measureTypes = measureTypes;
        },
        SET_MEASURE_TYPE_TEMPLATES(state: GapState, measureTypeTemplates: Array<any>) {
            state.measureTypeTemplates = measureTypeTemplates;
        },
        SET_PRIORITY(state: GapState, priority: Array<any>) {
            state.priority = priority;
        },
        SET_STATUS(state: GapState, status: Array<any>) {
            state.status = status;
        },
        SET_SUB_STATUS(state: GapState, subStatus: Array<any>) {
            state.subStatus = subStatus;
        },
        SET_CLOSE_REASONS(state: GapState, reasons: Array<any>) {
            state.closeReasons = reasons;
        },
        SET_LOG_TYPES(state: GapState, logTypes: Array<any>) {
            state.logTypes = logTypes;
        },
        RESET_STATE(state: GapState) {
            Object.assign(state, getDefaultState())
        }
    },
    actions: {
        async getList({ rootState }, filter: GapFilter) {
            // SET FORM DATA
            const params = new FormData();
            const entityId: number = rootState.auth.entityId;
            if (entityId != 0) {
                params.append('entityId', String(entityId));
            }
            if (filter.providerList && filter.providerList.length) {
                params.append('providerList', filter.providerList.join());
            }
            if (filter.excludedStatusList && filter.excludedStatusList.length) {
                params.append('excludedStatusList', filter.excludedStatusList.map(status => {
                    return "'" + status + "'";
                }).join(","));
            }
            if (filter.excludedSubStatusList && filter.excludedSubStatusList.length) {
                params.append('excludedSubStatusList', filter.excludedSubStatusList.map(status => {
                    return "'" + status + "'";
                }).join(","));
            }
            params.append('campaignId', filter.campaignId);
            params.append('insurerId', filter.insurerId);
            params.append('insurerMemberId', filter.insurerMemberId);
            params.append('providerId', filter.providerId);
            params.append('providerNPI', filter.providerNPI);
            params.append('measureTypeId', filter.measureTypeId);
            params.append('measureId', filter.measureId);
            params.append('patientFirstName', filter.patientFirstName);
            params.append('patientLastName', filter.patientLastName);
            params.append('patientInsurerMemberId', filter.patientInsurerMemberId);
            params.append('priorityId', filter.priorityId);
            params.append('statusId', filter.statusId);
            params.append('subStatusId', filter.subStatusId);
            params.append('referenceDateFrom', moment(filter.referenceDateFrom).format("YYYY-MM-DD"));
            params.append('referenceDateTo', moment(filter.referenceDateTo).format("YYYY-MM-DD"));
            params.append('recordDateFrom', moment(filter.recordDateFrom).format("YYYY-MM-DD"));
            params.append('recordDateTo', moment(filter.recordDateTo).format("YYYY-MM-DD"));
            params.append('orderBy', filter.orderBy);
            params.append('pageNumber', String(filter.pageNumber));
            params.append('rowsPerPage', String(filter.rowsPerPage));
            // GET GAP LIST ASYNC
            const { data } = await Vue.axios.post('gaps/list', params);
            //
            return data;
        },
        async getUserEnrolledProviderGapList({ rootState }, filter: GapFilter) {
            // SET FORM DATA
            const params = new FormData();
            if (filter.providerList && filter.providerList.length) {
                params.append('providerList', filter.providerList.join());
            }
            if (filter.excludedStatusList && filter.excludedStatusList.length) {
                params.append('excludedStatusList', filter.excludedStatusList.map(status => {
                    return "'" + status + "'";
                }).join(","));
            }
            if (filter.excludedSubStatusList && filter.excludedSubStatusList.length) {
                params.append('excludedSubStatusList', filter.excludedSubStatusList.map(status => {
                    return "'" + status + "'";
                }).join(","));
            }
            params.append('campaignId', filter.campaignId);
            params.append('insurerId', filter.insurerId);
            params.append('insurerMemberId', filter.insurerMemberId);
            params.append('providerId', filter.providerId);
            params.append('providerNPI', filter.providerNPI);
            params.append('measureTypeId', filter.measureTypeId);
            params.append('measureId', filter.measureId);
            params.append('patientFirstName', filter.patientFirstName);
            params.append('patientLastName', filter.patientLastName);
            params.append('patientInsurerMemberId', filter.patientInsurerMemberId);
            params.append('priorityId', filter.priorityId);
            params.append('statusId', filter.statusId);
            params.append('subStatusId', filter.subStatusId);
            params.append('referenceDateFrom', moment(filter.referenceDateFrom).format("YYYY-MM-DD"));
            params.append('referenceDateTo', moment(filter.referenceDateTo).format("YYYY-MM-DD"));
            params.append('recordDateFrom', moment(filter.recordDateFrom).format("YYYY-MM-DD"));
            params.append('recordDateTo', moment(filter.recordDateTo).format("YYYY-MM-DD"));
            params.append('orderBy', filter.orderBy);
            params.append('pageNumber', String(filter.pageNumber));
            params.append('rowsPerPage', String(filter.rowsPerPage));
            // GET GAP LIST ASYNC
            const { data } = await Vue.axios.post('gaps/user/provider/enrolled/gap/list', params);
            //
            return data;
        },
        async getGapProviders({ rootState }, gapList: string) {
            // SET FORM DATA
            const params = new FormData();
            const entityId: number = rootState.auth.entityId;
            if (entityId != 0) {
                params.append('entityId', String(entityId));
            }
            params.append('gapList', gapList);
            // GET GAP LIST ASYNC
            const { data } = await Vue.axios.post('gaps/list/providers', params);
            //
            return data;
        },
        async getFiles({ commit }, gapId: number) {
            // SET FORM DATA
            const params = new FormData();
            params.append("gapId", String(gapId));
            // GET GAP FILES ASYNC
            const { data } = await Vue.axios.post("gaps/file/list", params);
            //
            return data;
        },
        async getFileUrl({ commit }, { gapId, storageId }) {
            // SET FORM DATA
            const params = new FormData();
            params.append("gapId", gapId);
            params.append("storageId", storageId);
            // GET GAP FILE URL
            const { data } = await Vue.axios.post("gaps/file/url", params);
            //
            return data;
        },
        async getFileDownloadUrl({ commit }, { gapId, storageId }) {
            // SET FORM DATA
            const params = new FormData();
            params.append("gapId", gapId);
            params.append("storageId", storageId);
            // GET GAP FILE URL
            const { data } = await Vue.axios.post("gaps/file/url/download", params);
            //
            return data;
        },
        async getCount({ rootState }, filter: GapFilter) {
            // SET FORM DATA
            const params = new FormData();
            const entityId: number = rootState.auth.entityId;
            if (entityId != 0) {
                params.append('entityId', String(entityId));
            }
            //
            params.append('campaignId', String(filter.campaignId));
            params.append('insurerId', String(filter.insurerId));
            params.append('insurerMemberId', filter.insurerMemberId);
            params.append('providerId', String(filter.providerId));
            params.append('measureTypeId', filter.measureTypeId);
            params.append('measureId', String(filter.measureId));
            params.append('patientFirstName', filter.patientFirstName);
            params.append('patientLastName', filter.patientLastName);
            params.append('patientInsurerMemberId', filter.patientInsurerMemberId);
            params.append('referenceDateFrom', moment(filter.referenceDateFrom).format("YYYY-MM-DD"));
            params.append('referenceDateTo', moment(filter.referenceDateTo).format("YYYY-MM-DD"));
            params.append('recordDateFrom', moment(filter.recordDateFrom).format("YYYY-MM-DD"));
            params.append('recordDateTo', moment(filter.recordDateTo).format("YYYY-MM-DD"));
            // GET STATUS COUNT ASYNC
            const { data } = await Vue.axios.post('gaps/count', params)
            //
            return data;
        },
        async getPriorityCount({ rootState }, filter: GapFilter) {
            // SET FORM DATA
            const params = new FormData();
            const entityId: number = rootState.auth.entityId;
            if (entityId != 0) {
                params.append('entityId', String(entityId));
            }
            params.append('campaignId', String(filter.campaignId));
            params.append('insurerId', String(filter.insurerId));
            params.append('insurerMemberId', filter.insurerMemberId);
            params.append('providerId', String(filter.providerId));
            params.append('measureTypeId', filter.measureTypeId);
            params.append('measureId', String(filter.measureId));
            params.append('patientFirstName', filter.patientFirstName);
            params.append('patientLastName', filter.patientLastName);
            params.append('patientInsurerMemberId', filter.patientInsurerMemberId);
            params.append('referenceDateFrom', moment(filter.referenceDateFrom).format("YYYY-MM-DD"));
            params.append('referenceDateTo', moment(filter.referenceDateTo).format("YYYY-MM-DD"));
            params.append('recordDateFrom', moment(filter.recordDateFrom).format("YYYY-MM-DD"));
            params.append('recordDateTo', moment(filter.recordDateTo).format("YYYY-MM-DD"));
            // GET STATUS COUNT ASYNC
            const { data } = await Vue.axios.post('gaps/count/priority', params)
            //
            return data;
        },
        async getStatusCount({ rootState }, filter: GapFilter) {
            // SET FORM DATA
            const params = new FormData();
            const entityId: number = rootState.auth.entityId;
            if (entityId != 0) {
                params.append('entityId', String(entityId));
            }
            params.append('campaignId', String(filter.campaignId));
            params.append('insurerId', String(filter.insurerId));
            params.append('insurerMemberId', filter.insurerMemberId);
            params.append('providerId', String(filter.providerId));
            params.append('measureTypeId', filter.measureTypeId);
            params.append('measureId', String(filter.measureId));
            params.append('patientFirstName', filter.patientFirstName);
            params.append('patientLastName', filter.patientLastName);
            params.append('patientInsurerMemberId', filter.patientInsurerMemberId);
            params.append('referenceDateFrom', moment(filter.referenceDateFrom).format("YYYY-MM-DD"));
            params.append('referenceDateTo', moment(filter.referenceDateTo).format("YYYY-MM-DD"));
            params.append('recordDateFrom', moment(filter.recordDateFrom).format("YYYY-MM-DD"));
            params.append('recordDateTo', moment(filter.recordDateTo).format("YYYY-MM-DD"));
            // GET STATUS COUNT ASYNC
            const { data } = await Vue.axios.post('gaps/count/status', params)
            //
            return data;
        },
        async getSubStatusCount({ rootState }, filter: GapFilter) {
            // SET FORM DATA
            const params = new FormData();
            const entityId: number = rootState.auth.entityId;
            if (entityId != 0) {
                params.append('entityId', String(entityId));
            }
            params.append('campaignId', String(filter.campaignId));
            params.append('insurerId', String(filter.insurerId));
            params.append('insurerMemberId', filter.insurerMemberId);
            params.append('providerId', String(filter.providerId));
            params.append('measureTypeId', filter.measureTypeId);
            params.append('measureId', String(filter.measureId));
            params.append('patientFirstName', filter.patientFirstName);
            params.append('patientLastName', filter.patientLastName);
            params.append('patientInsurerMemberId', filter.patientInsurerMemberId);
            params.append('referenceDateFrom', moment(filter.referenceDateFrom).format("YYYY-MM-DD"));
            params.append('referenceDateTo', moment(filter.referenceDateTo).format("YYYY-MM-DD"));
            params.append('recordDateFrom', moment(filter.recordDateFrom).format("YYYY-MM-DD"));
            params.append('recordDateTo', moment(filter.recordDateTo).format("YYYY-MM-DD"));
            // GET SUB-STATUS COUNT ASYNC
            const { data } = await Vue.axios.post('gaps/count/substatus', params)
            //
            return data;
        },
        async getRecord({ commit }, id: number) {
            // SET FORM DATA
            const params = new FormData();
            params.append('id', String(id));
            // GET GAP ASYNC
            const { data } = await Vue.axios.post('gaps/record', params);
            //
            return data;
        },
        async getLogById({ commit }, id: number) {
            // SET FORM DATA
            const params = new FormData();
            params.append('id', String(id));
            // SET GAP LOG ASYNC
            const { data } = await Vue.axios.post('gaps/log', params);
            //
            return data;
        },
        async getLogTypes({ commit, state }) {
            if (state.logTypes.length) return;
            // GET LOG TYPES ASYNC
            const { data } = await Vue.axios.post('gaps/log/type/list');
            //
            commit("SET_LOG_TYPES", data);
            return data;
        },
        async getMeasures({ commit, state }) {
            if (state.measures.length) return;
            // GET MEASURES ASYNC
            const { data } = await Vue.axios.post('gaps/measure/list');
            //
            commit("SET_MEASURES", data);
        },
        async getMeasureTypes({ commit, state }) {
            if (state.measureTypes.length) return;
            // GET MEASURE TYPES ASYNC
            const { data } = await Vue.axios.post('gaps/measure/type/list');
            //
            commit("SET_MEASURE_TYPES", data);
        },
        async getMeasureTypeTemplates({ rootState }, measureTypeId: string) {
            // SET FORM DATA
            const params = new FormData();
            const entityId: number = rootState.auth.entityId;
            params.append('entityId', String(entityId));
            params.append('measureTypeId', measureTypeId);
            // GET TEMPLATES ASYNC
            const { data } = await Vue.axios.post('gaps/measure/type/template/list', params);
            //
            return data;
        },
        async getProviderTemplates({ rootState }, measureTypeId: string) {
            // SET FORM DATA
            const params = new FormData();
            const entityId: number = rootState.auth.entityId;
            params.append('entityId', String(entityId));
            params.append('measureTypeId', measureTypeId);
            // GET TEMPLATES ASYNC
            const { data } = await Vue.axios.post('gaps/provider/template/list', params);
            //
            return data;
        },
        async getPriority({ commit, state }) {
            if (state.priority.length) return;
            // GET PRIORITY LIST ASYNC
            const { data } = await Vue.axios.post('gaps/priority/list');
            //
            commit("SET_PRIORITY", data);
        },
        async getStatus({ commit, state }) {
            if (state.status.length) return;
            // GET STATUS LIST ASYNC
            const { data } = await Vue.axios.post('gaps/status/list');
            //
            commit("SET_STATUS", data);
        },
        async getSubStatus({ commit, state }) {
            if (state.subStatus.length) return;
            // GET SUB-STATUS LIST ASYNC
            const { data } = await Vue.axios.post('gaps/substatus/list');
            //
            commit("SET_SUB_STATUS", data);
        },
        async getCloseReasons({ commit, rootState }) {
            // SET FORM PARAMS
            const params = new FormData();
            const entityId: number = rootState.auth.entityId;
            params.append('entityId', String(entityId));
            //
            const { data } = await Vue.axios.post('gaps/close/reason/list', params)
            commit("SET_CLOSE_REASONS", data);
        },
        async getCloseSubReasons({ commit, rootState }, reasonId: string) {
            // SET FORM PARAMS
            const params = new FormData();
            const entityId: number = rootState.auth.entityId;
            params.append('entityId', String(entityId));
            params.append('reasonId', String(reasonId));
            // GET SUB-REASONS ASYNC
            const { data } = await Vue.axios.post('gaps/close/subreason/list', params)
            //
            return data;
        },
        async getCampaigns({ commit, rootState }) {
            // SET FORM PARAMS
            const params = new FormData();
            const entityId: number = rootState.auth.entityId;
            if (entityId != 0) {
                params.append('entityId', String(entityId));
            }
            //
            const { data } = await Vue.axios.post('gaps/campaign/list', params);
            commit("SET_CAMPAIGNS", data);
        },
        async getInsurers({ commit, rootState }) {
            // SET FORM PARAMS
            const params = new FormData();
            const entityId: number = rootState.auth.entityId;
            if (entityId != 0) {
                params.append('entityId', String(entityId));
            }
            //
            const { data } = await Vue.axios.post('gaps/insurer/list', params);
            commit("SET_INSURERS", data);
        },
        async getProviders({ commit, rootState }) {
            // SET FORM PARAMS
            const params = new FormData();
            const entityId: number = rootState.auth.entityId;
            if (entityId != 0) {
                params.append('entityId', String(entityId));
            }
            //
            const { data } = await Vue.axios.post('gaps/provider/list', params)
            commit("SET_PROVIDERS", data);
        },
        async getPatients({ rootState }, filter: GapPatientFilter) {
            // SET FORM DATA
            const params = new FormData();
            const entityId: number = rootState.auth.entityId;
            if (entityId != 0) {
                params.append('entityId', String(entityId));
            }
            params.append('firstName', filter.firstName);
            params.append('lastName', filter.lastName);
            params.append('insurerMemberId', filter.insurerMemberId);
            params.append('EMR_ID', filter.EMR_ID);
            // GET GAP PATIENTS ASYNC
            const { data } = await Vue.axios.post('gaps/patient/list', params)
            //
            return data;
        },
        async getSummary({ rootState }) {
            // SET FORM DATA
            const params = new FormData();
            const entityId: number = rootState.auth.entityId;
            if (entityId != 0) {
                params.append('entityId', String(entityId));
            }
            // GET REPORT ASYNC
            const { data } = await Vue.axios.post('gaps/report', params)
            //
            return data;
        },
        async save({ rootState }, gap: GapRecord) {
            // SET FORM DATA
            const params = new FormData();
            const entityId: number = rootState.auth.entityId;
            if (gap.id) {
                params.append('id', String(gap.id));
            }
            params.append('entityId', String(entityId));
            params.append('campaignId', String(gap.campaignId));
            params.append('providerId', String(gap.providerId));
            params.append('insurerId', String(gap.insurerId));
            params.append('insurerMemberId', gap.insurerMemberId);
            params.append('patientId', String(gap.patientId));
            params.append('patientPhoneType', gap.patientPhoneType);
            params.append('patientPhone', gap.patientPhone);
            params.append('measureId', String(gap.measureId));
            params.append('referenceDate', moment(gap.referenceDate).format("YYYY-MM-DD"));
            params.append('admissionDate', moment(gap.admissionDate).format("YYYY-MM-DD"));
            params.append('admissionDiagnosis', gap.admissionDiagnosis);
            params.append('admissionProviderName', gap.admissionProviderName);
            params.append('testDate', moment(gap.testDate).format("YYYY-MM-DD"));
            params.append('testResultValue', gap.testResultValue);
            params.append('dischargeDiagnosis', gap.dischargeDiagnosis);
            params.append('facilityName', gap.facilityName);
            params.append('pharmacyName', gap.pharmacyName);
            params.append('medicationName', gap.medicationName);
            params.append('comment', gap.comment);
            params.append('lang', gap.lang);
            params.append('priorityId', gap.priorityId);
            params.append('statusId', gap.statusId);
            params.append('subStatusId', gap.subStatusId);
            params.append('closeReasonId', gap.closeReasonId);
            params.append('closeSubReasonId', gap.closeSubReasonId);
            params.append('closeDate', moment(gap.closeDate).format("YYYY-MM-DD"));
            // SAVE GAP ASYNC
            const { data } = await Vue.axios.post('gaps/save', params);
            //
            return data;
        },
        async saveLog({ commit }, entry: GapLogEntry) {
            // SET FORM DATA
            const params = new FormData();
            params.append('gapId', String(entry.gapId));
            params.append('typeId', entry.typeId);
            params.append('statusId', entry.statusId ? String(entry.statusId) : "");
            params.append('subStatusId', entry.subStatusId ? String(entry.subStatusId) : "");
            params.append('comment', entry.comment ? entry.comment : "");
            // SAVE GAP LOG ASYNC
            const { data } = await Vue.axios.post('gaps/log/save', params);
            //
            return data;
        },
        async saveSystemLog({ commit }, entry: GapLogEntry) {
            // SET FORM DATA
            const params = new FormData();
            params.append('gapId', String(entry.gapId));
            params.append('typeId', entry.typeId);
            params.append('statusId', entry.statusId ? String(entry.statusId) : "");
            params.append('subStatusId', entry.subStatusId ? String(entry.subStatusId) : "");
            params.append('comment', entry.comment ? entry.comment : "");
            // SAVE GAP LOG ASYNC
            const { data } = await Vue.axios.post('gaps/log/save/system', params);
            //
            return data;
        },
        async savePriority({ commit }, { gapId, gapList, priorityId }) {
            // SET FORM DATA
            const params = new FormData();
            params.append('gapId', gapId ? gapId : "");
            params.append('gapList', gapList ? gapList : "");
            params.append('priorityId', priorityId);
            // SAVE GAP LOG ASYNC
            const { data } = await Vue.axios.post('gaps/priority/save', params);
            //
            return data;
        },
        async saveStatus({ commit }, { gapId, gapList, statusId }) {
            // SET FORM DATA
            const params = new FormData();
            params.append('gapId', gapId ? gapId : "");
            params.append('gapList', gapList ? gapList : "");
            params.append('statusId', statusId);
            // SAVE GAP LOG ASYNC
            const { data } = await Vue.axios.post('gaps/status/save', params);
            //
            return data;
        },
        async saveSubStatus({ commit }, { gapId, gapList, subStatusId }) {
            // SET FORM DATA
            const params = new FormData();
            params.append('gapId', gapId ? gapId : "");
            params.append('gapList', gapList ? gapList : "");
            params.append('subStatusId', subStatusId);
            // SAVE GAP LOG ASYNC
            const { data } = await Vue.axios.post('gaps/substatus/save', params);
            //
            return data;
        }
    }
}
